module.exports = __webpack_public_path__ + "static/media/HAPPYHAIR_w.3da7cfda.png";